import { Paper, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ListContainer = styled(Paper)(({ theme }) => ({
  width: "100%",
  maxWidth: 1230,
  margin: "16px auto",
  padding: theme.spacing(2),
  boxShadow: theme.shadows[3],
  borderRadius: 12,
}));

export const StyledCard = styled("li")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  borderRadius: 10,
  padding: theme.spacing(1.5),
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  marginBottom: theme.spacing(1.5),
  listStyle: "none",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    transform: "translateY(-2px)",
  },
}));

export const InfoBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
}));

export const StyledNameField = styled(Typography)(() => ({
  fontWeight: 600,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: 260,
  textTransform: "uppercase",
  fontSize: 14,
}));

export const StyledTitleField = styled(Typography)(() => ({
  fontWeight: 700,
  color: "#0B3095",
  textTransform: "uppercase",
  fontSize: 14,
}));
